import styled from 'styled-components'
import { taskCadenceLabel } from 'features/taskManagement/recurrenceLabel'

const TaskCadenceBadge = ({ task, className }) => {
  const label = taskCadenceLabel(task)
  if (!label) return null
  return (
    <Badge className={className} title='How often this recurs'>
      {label}
    </Badge>
  )
}

export default TaskCadenceBadge

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.4;
  padding: 1px 7px;
  border-radius: 10px;
  color: #64748b;
  background: #eef2f6;
  white-space: nowrap;
`
